import { css } from '@emotion/react'

type TableRowDataProps = {
	width?: number
	align?: 'left' | 'right' | 'center' | 'justify' | 'char'
	children: React.ReactNode
}

const TableRowData = ({ width, align, children }: TableRowDataProps) => {
	return (
		<td css={tableDataStyle(width)} align={align}>
			{children}
		</td>
	)
}

const tableDataStyle = (width?: number) => css`
	vertical-align: middle;
	padding: 1rem 0.5rem;
	border: 1px solid #dbdbdb;
	letter-spacing: 0.02rem;
	font-size: 1.2rem;
	line-height: 2rem;
	white-space: pre-wrap;
	word-break: break-all;
	min-width: ${width}rem;
	max-width: ${width}rem;
`

export default TableRowData
